module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_9005.1f15aa77.png";